<div>
  <form [formGroup]="form" (ngSubmit)="onSubmit()">
    <div class="container full-width">
      <div class="row">
        <!-- Name EN -->
        <app-input type="text" formControlName="name_en" appearance="fill" [fullWidth]="true" extraLabel="true"
                   class="col-12"
                   [label]="'CASE_CREDITOR.case_creditor_status.status_name_en' | translate">
        </app-input>
      </div>
      <div class="row">
        <!-- Name ES -->
        <app-input type="text" formControlName="name_es" appearance="fill" [fullWidth]="true" extraLabel="true"
                   class="col-12"
                   [label]="'CASE_CREDITOR.case_creditor_status.status_name_es' | translate">
        </app-input>
      </div>
      <div class="row">
        <!-- Is for Bulk DM -->
        <app-input type="checkbox" formControlName="is_for_bulk_dm" appearance="fill" [fullWidth]="true"
                   extraLabel="true" class="col-12"
                   [label]="'CASE_CREDITOR.case_creditor_status.is_for_bulk_dm' | translate">
        </app-input>
      </div>
      <div class="row">
        <!-- Is System Status -->
        <app-input type="checkbox" formControlName="exclude_from_distribution" appearance="fill" [fullWidth]="true"
                   extraLabel="true" class="col-12"
                   [label]="'CASE_CREDITOR.case_creditor_status.exclude_from_distribution' | translate">
        </app-input>
      </div>
      <div class="row">
        <!-- Is System Status -->
        <app-input type="checkbox" formControlName="is_system_status" appearance="fill" [fullWidth]="true"
                   extraLabel="true" class="col-12"
                   [label]="'CASE_CREDITOR.case_creditor_status.is_system_status' | translate">
        </app-input>
      </div>
      <div class="row">
        <!-- Zero active debt -->
        <app-input type="checkbox" formControlName="zero_active_debt" appearance="fill" [fullWidth]="true"
                   extraLabel="true" class="col-12"
                   [label]="'CASE_CREDITOR.case_creditor_status.zero_active_debt' | translate">
        </app-input>
      </div>
      <div class="row">
        <!-- Create fees -->
        <app-input *ngIf="false" type="checkbox" [formControl]="createFees" appearance="fill" [fullWidth]="true"
                   extraLabel="true" class="col-12"
                   [label]="'Create fee' | translate">
        </app-input>
      </div>

      <ng-container *ngIf="showPaymentPlanTypes">
        <div class="row">
          <app-input type="select" formControlName="is_installment_fee" appearance="fill" [fullWidth]="true"
                     [label]="'Installment type' | translate" extraLabel="true" class="col-12" (ngModelChange)="installmentOptionChanged($event)"
                     [selectOptions]="installmentOptions" selectLabel="label" selectValue="value">
          </app-input>
        </div>
        <div class="row">
          <app-input type="select" formControlName="payment_plan_type_id" appearance="fill" fullWidth="false"
                     [label]="'PAYMENTS.list.filters.payment_plan_type.label' | translate" extraLabel="true" class="col-12"
                     [selectOptions]="paymentPlanTypes" [selectLabel]="'name'" [selectValue]="'id'">
          </app-input>
        </div>
        <div class="row">
          <app-input type="select" formControlName="amount_type" appearance="fill" [fullWidth]="true"
                     [label]="'Amount type' | translate" extraLabel="true" class="col-12"
                     [selectOptions]="amountTypeOptions" selectLabel="label" selectValue="value">
          </app-input>
        </div>
        <div class="row" *ngIf="showFixedAmount">
          <app-input type="number" formControlName="fixed_amount" appearance="fill" [fullWidth]="true"
                     [label]="'Fixed amount' | translate" extraLabel="true" class="col-12">
          </app-input>
        </div>
      </ng-container>

      <div class="row">
        <!-- Slug -->
        <app-input type="text" formControlName="slug" appearance="fill" [fullWidth]="true" extraLabel="true"
                   class="col-12"
                   label="Slug">
        </app-input>
      </div>
      <div class="row">
        <!-- Flag Case Active -->
        <app-input type="checkbox" formControlName="flag_case_creditor_active" appearance="fill" [fullWidth]="true" extraLabel="true" class="col-12"
                   [label]="'CONFIG.status.editor.form.flag_case_active' | translate">
        </app-input>
      </div>
      <div class="row">
        <!-- Completed -->
        <app-input type="checkbox" formControlName="flag_case_creditor_complete" appearance="fill" [fullWidth]="true" extraLabel="true" class="col-12"
                   [label]="'CONFIG.status.editor.form.flag_case_complete' | translate">
        </app-input>
      </div>
      <div class="row">
        <!-- Product -->
        <app-input type="select" formControlName="set_product_id" appearance="standard"
                   [label]="'CASES.single.general.status_editor.product' | translate" [extraLabel]="true"
                   [selectOptions]="products" [selectLabel]="['name']" [selectValue]="'id'" class="full-width"
                   [showClear]="false" [fullWidth]="true" [showLabel]="true" [searchable]="true">
        </app-input>
      </div>
      <div class="row pt-5">
        <div class="col-md-4">
          <button mat-raised-button color="primary" class="ml-3" type="submit">
            {{ 'SHARED.save' | translate }}
          </button>
        </div>
      </div>
    </div>
  </form>
</div>
